<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <sot-countdown [controls]="false" [countdown_sec]="timeout"
      (statusChanged)="countdownStatusChanged($event)"></sot-countdown>
  </header>
  <p [langkey]="text"></p>

  <footer class="buttons">
    <a *ngFor="let btn of buttons" class="btn {{btn.style}}" (click)="btn.onClick(dialogRef)"
      [langkey]="btn.langkey"></a>
  </footer>
</div>